import { Component, OnInit } from '@angular/core';
import { ResponsiveScreenService } from '../../services/responsive-screen.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-introduction-section',
    templateUrl: './introduction-section.component.html',
    styleUrls: ['./introduction-section.component.scss'],
    standalone: true,
    imports: [NgIf, TranslateModule]
})
export class IntroductionSectionComponent {
    constructor(public responsiveScreenService: ResponsiveScreenService) { }
}
